export const parseNumberOrEmpty = (value: string | null): number | '' => {
  if (value === null || value === '') {
    return ''; // 未指定は空文字
  }
  return Number(value); // "0" は 0 (数値) になる
};